import {Get_AdminBundlestatus} from '../constants/ActionTypes'

const INIT_STATE = {
    Statuslist1: null,
    AdminBundleMessage:'',
    AdminBundleStatus:''
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case Get_AdminBundlestatus:
            return {
                Statuslist1: action.body,
                AdminBundleMessage:action.statusAdmnMessage,
                AdminBundleStatus:action.admnBundlestatus
              
            }
           

        default:
            return state;
    }
}